import React from 'react'

import {GlistSkin} from "../../../const"

export default function GroupHeaderArrow(props: {
    module      : any,
    isCollapsed : boolean
}) {

    switch (props.module.skinName) {
        case GlistSkin.SKIN_CARDS   :
            return (
                <div className={Classes("toggle-arrow ui5-c-e-toggle m-r-8", {
                    'i5-angle-down' : !props.isCollapsed,
                    'i5-angle-right': props.isCollapsed,
                })}/>
            )

        case GlistSkin.SKIN_MODERN  :
        default                     :
            return (
                <div className={Classes("toggle-arrow ui5-arrow-toggle s8 m-r-8", {
                    open    : !props.isCollapsed,
                    closed  : props.isCollapsed,
                })}/>
            )
    }
}
